import { render, staticRenderFns } from "./JDictCodeSelectTag.vue?vue&type=template&id=67143980&scoped=true"
import script from "./JDictCodeSelectTag.vue?vue&type=script&lang=js"
export * from "./JDictCodeSelectTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67143980",
  null
  
)

export default component.exports